import { SystemLanguages } from "../../shared/enums/shared-enums";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";

export class RoutesLogic {
  private static hasSystemLanguageType = [
    SystemEntityCollections.VERSION,
    SystemEntityCollections.TEXT,
    SystemEntityCollections.WORK,
    SystemEntityCollections.TEAM,
  ];

  static getInitialRoute(collection: SystemEntityCollections): string {
    switch (collection) {
      case SystemEntityCollections.PERSON:
        return "persons";
      case SystemEntityCollections.PLACE:
        return "places";
      case SystemEntityCollections.TEAM:
        return "teams";
      case SystemEntityCollections.COLOPHON:
        return "colophons";
      case SystemEntityCollections.BIBLIOGRAPHY:
        return "bibliographies";
      case SystemEntityCollections.WORK:
        return "works";
      case SystemEntityCollections.TEXT:
        return "texts";
      case SystemEntityCollections.VERSION:
        return "versions";
      case SystemEntityCollections.USER_ENUM:
        return "codes";
      default:
        throw new Error("Invalid collection");
    }
  }

  private static addSystemLanguageType = (
    collection: SystemEntityCollections,
    systemLanguageType?: SystemLanguages | string
  ): string =>
    this.hasSystemLanguageType.includes(collection)
      ? systemLanguageType
        ? `/${systemLanguageType}`
        : "/:system_language_type"
      : "";

  static getTableRoute = (
    collection: SystemEntityCollections,
    systemLanguageType?: SystemLanguages | string
  ): string =>
    `${this.getInitialRoute(collection)}${this.addSystemLanguageType(collection, systemLanguageType)}`;

  static getMainRoute = (
    collection: SystemEntityCollections,
    systemLanguageType?: SystemLanguages | string
  ): string =>
    `${this.getInitialRoute(collection)}${this.addSystemLanguageType(collection, systemLanguageType)}/*`;

  static getCreateRoute = (
    collection: SystemEntityCollections,
    systemLanguageType?: SystemLanguages | string
  ): string =>
    `${this.getInitialRoute(collection)}${this.addSystemLanguageType(collection, systemLanguageType)}/create`;

  static getEditRoute = (
    collection: SystemEntityCollections,
    systemLanguageType?: SystemLanguages | string,
    key?: string | number
  ): string =>
    `${this.getInitialRoute(collection)}${this.addSystemLanguageType(collection, systemLanguageType)}/${key || ":_id"}/edit`;

  static getViewRoute = (
    collection: SystemEntityCollections,
    systemLanguageType?: SystemLanguages | string,
    key?: string | number
  ): string =>
    `${this.getInitialRoute(collection)}${this.addSystemLanguageType(collection, systemLanguageType)}/${key || ":_id"}`;
}
